var map = {
	"./fonts/_beachday.ttf": "cb3c",
	"./images/bridge/coin.png": "0146",
	"./images/btn-base.svg": "3519",
	"./images/btn-top.png": "5a85",
	"./images/btn-top.svg": "9264",
	"./images/claw.png": "b331",
	"./images/cloud-r.png": "893b",
	"./images/cloud.png": "9c9c",
	"./images/collection/1.png": "d142",
	"./images/collection/10.png": "cd45",
	"./images/collection/11.png": "cd87",
	"./images/collection/12.png": "5bfa",
	"./images/collection/13.png": "180e",
	"./images/collection/14.png": "d0bb",
	"./images/collection/15.png": "b3f4",
	"./images/collection/16.png": "c8ac",
	"./images/collection/17.png": "bdc3",
	"./images/collection/18.png": "9274",
	"./images/collection/19.png": "8b7a",
	"./images/collection/2.png": "79f3",
	"./images/collection/20.png": "8063",
	"./images/collection/21.png": "af71",
	"./images/collection/22.png": "95ee",
	"./images/collection/23.png": "5b97",
	"./images/collection/24.png": "4f91",
	"./images/collection/3.png": "fa87",
	"./images/collection/4.png": "d30c",
	"./images/collection/5.png": "2331",
	"./images/collection/6.png": "501d",
	"./images/collection/7.png": "6502",
	"./images/collection/8.png": "f978",
	"./images/collection/9.png": "3148",
	"./images/country/cn.svg": "2924",
	"./images/country/en.svg": "c96f",
	"./images/country/es.svg": "7681",
	"./images/country/jp.svg": "2318",
	"./images/country/ru.svg": "cfd7",
	"./images/country/th.svg": "7c38",
	"./images/country/vn.svg": "7224",
	"./images/floor.svg": "89be",
	"./images/herov2/blue-shadow.png": "2278",
	"./images/herov2/blue.png": "87b8",
	"./images/herov2/descend.png": "80dc",
	"./images/herov2/dragon.png": "ab40",
	"./images/herov2/grass-blue.png": "cac2",
	"./images/herov2/grass.png": "7fcd",
	"./images/herov2/hill-alone.png": "20c8",
	"./images/herov2/hill-tree.png": "c484",
	"./images/herov2/hill.png": "5945",
	"./images/herov2/ip.png": "4b11",
	"./images/herov2/logo.png": "1376",
	"./images/herov2/metaverse.jpg": "74f8",
	"./images/herov2/night.png": "e8a9",
	"./images/herov2/pink-pumpkin.png": "a665",
	"./images/herov2/pink-shadow.png": "95e0",
	"./images/herov2/pink.png": "0f02",
	"./images/herov2/previews/descend-1.mp4": "b174",
	"./images/herov2/previews/descend-2.png": "771e",
	"./images/herov2/previews/descend-3.png": "e4ac",
	"./images/herov2/previews/ip-1.mp4": "e333",
	"./images/herov2/previews/ip-2.png": "72f1",
	"./images/herov2/previews/ip-3.png": "9732",
	"./images/herov2/previews/ip-4.png": "ce6a",
	"./images/herov2/previews/metaverse-1.mp4": "0ae1",
	"./images/herov2/previews/metaverse-2.mp4": "9750",
	"./images/herov2/previews/metaverse-3.png": "564b",
	"./images/herov2/previews/squishiland-1.mp4": "987f",
	"./images/herov2/previews/squishiland-2.png": "cc17",
	"./images/herov2/previews/squishiland-3.png": "c568",
	"./images/herov2/record.jpg": "3ba2",
	"./images/herov2/sky.png": "9241",
	"./images/herov2/squishiland-bg.png": "926c",
	"./images/herov2/squishiland-land.png": "bbba",
	"./images/herov2/team.jpg": "5abd",
	"./images/logo.svg": "e347",
	"./images/lootbox/Chest1200x1400.webm": "94f1",
	"./images/lootbox/bg.jpg": "dfd2",
	"./images/lootbox/bg2.jpg": "ce25",
	"./images/lootbox/contracts/1.png": "8162",
	"./images/lootbox/contracts/10.png": "26b5",
	"./images/lootbox/contracts/11.png": "3e15",
	"./images/lootbox/contracts/12.png": "7a7e",
	"./images/lootbox/contracts/2.gif": "b3d6",
	"./images/lootbox/contracts/3.png": "5feb",
	"./images/lootbox/contracts/4.png": "637a",
	"./images/lootbox/contracts/5.png": "fd61",
	"./images/lootbox/contracts/6.png": "c35d",
	"./images/lootbox/contracts/7.png": "947a",
	"./images/lootbox/contracts/8.png": "d490",
	"./images/lootbox/contracts/9.png": "8bd5",
	"./images/lootbox/items/0.png": "fff5",
	"./images/lootbox/items/1.png": "62da",
	"./images/lootbox/items/10.png": "4aa8",
	"./images/lootbox/items/11.png": "2eea",
	"./images/lootbox/items/12.png": "58c2",
	"./images/lootbox/items/13.png": "e45d",
	"./images/lootbox/items/14.png": "6e78",
	"./images/lootbox/items/15.png": "eae5",
	"./images/lootbox/items/16.png": "ff35",
	"./images/lootbox/items/17.png": "e15d",
	"./images/lootbox/items/18.png": "a8aa",
	"./images/lootbox/items/19.png": "f40d",
	"./images/lootbox/items/2.png": "36f9",
	"./images/lootbox/items/20.png": "f63e",
	"./images/lootbox/items/3.png": "4cd7",
	"./images/lootbox/items/4.png": "b368",
	"./images/lootbox/items/5.png": "2970",
	"./images/lootbox/items/6.png": "61174",
	"./images/lootbox/items/7.png": "57f4",
	"./images/lootbox/items/8.png": "d9d5",
	"./images/lootbox/items/9.png": "076d",
	"./images/lootbox/lootboxes/common.mov": "6d3a",
	"./images/lootbox/lootboxes/common.png": "5398",
	"./images/lootbox/lootboxes/common.webm": "64c7",
	"./images/lootbox/lootboxes/legendary.mov": "8022",
	"./images/lootbox/lootboxes/legendary.png": "848a",
	"./images/lootbox/lootboxes/legendary.webm": "a400",
	"./images/lootbox/lootboxes/mythic.mov": "aa2d",
	"./images/lootbox/lootboxes/mythic.png": "9161",
	"./images/lootbox/lootboxes/mythic.webm": "103d",
	"./images/lootbox/lootboxes/og": "19b5",
	"./images/lootbox/lootboxes/og.json": "19b5",
	"./images/lootbox/lootboxes/og.mov": "a54b",
	"./images/lootbox/lootboxes/og.png": "9dcf",
	"./images/lootbox/lootboxes/og.webm": "1722",
	"./images/lootbox/lootboxes/rare.mov": "2b50",
	"./images/lootbox/lootboxes/rare.png": "2355",
	"./images/lootbox/lootboxes/rare.webm": "91be",
	"./images/lootbox/lootboxes/uncommon.mov": "1313",
	"./images/lootbox/lootboxes/uncommon.png": "8e7a",
	"./images/lootbox/lootboxes/uncommon.webm": "cb68",
	"./images/lootbox/sfx-opened.ogg": "faae",
	"./images/lootbox/sfx-opening.ogg": "3192",
	"./images/marketplace/bg.jpg": "8210",
	"./images/marketplace/clover.png": "845c",
	"./images/marketplace/modal.png": "05cb",
	"./images/navlogo.png": "129d",
	"./images/path.svg": "4452",
	"./images/preloader.png": "a19f",
	"./images/socials/Discord.svg": "2659",
	"./images/socials/Etherscan.svg": "39e4",
	"./images/socials/Gem.svg": "de17",
	"./images/socials/GitBook.svg": "7034",
	"./images/socials/Instagram.svg": "e649",
	"./images/socials/Opensea.svg": "b100",
	"./images/socials/Twitter.svg": "9b79",
	"./images/squishie-angel.png": "08fc",
	"./images/squishie-blue.gif": "7d71",
	"./images/squishie-blue.png": "1572",
	"./images/staking/bg.jpg": "1b27",
	"./images/staking/bg.png": "b415",
	"./images/staking/placeholder.gif": "6feb",
	"./images/staking/squishies.png": "4467",
	"./images/staking/treasure.png": "f965",
	"./images/team-bg.jpg": "1923",
	"./images/team/_Anna.png": "fff2",
	"./images/team/_BlueTiger.png": "2ea7",
	"./images/team/_Boneboy.png": "bba1",
	"./images/team/_Cheeky.png": "7849",
	"./images/team/_Clover.png": "cbb4",
	"./images/team/_Cole.png": "2f31",
	"./images/team/_HappyLuckyCharm.png": "e40c",
	"./images/team/_Lemon.png": "3499",
	"./images/team/_LemonBlue.png": "75e6",
	"./images/team/_Lew.png": "66ae",
	"./images/team/_Lozz.png": "857f",
	"./images/team/_Mooney.png": "6c39",
	"./images/team/_Nobi.png": "bb03",
	"./images/team/_Panchito.png": "7356",
	"./images/team/_QQ.png": "38e5",
	"./images/team/_Ryan.png": "a04f",
	"./images/team/_Shadow.png": "7d7f",
	"./images/team/_Smokey.png": "205e",
	"./images/team/_Sourbrick.png": "0e37",
	"./images/team/_Zeus.png": "b9cb",
	"./images/team/_akaCube.png": "6497",
	"./images/twitter.png": "9284",
	"./images/twitter.svg": "1538",
	"./logo.png": "cf05",
	"./scss/fonts.scss": "d624",
	"./scss/threedee_shadows.scss": "13d8",
	"./scss/vars.scss": "cdff",
	"./scss/web3.scss": "371a",
	"./sounds/main_theme.wav": "a929"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";